import axios from 'axios';

// Mixed into EventsList
export default {
  data(){
    return {
      events: [],
      eventsLoading: true,
      filterLoaded: false,
      filterKey: 0,
      currentFilter: {
        term: '',
        dateString: '',
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        accessibility: []
      },
      filterOptions: {
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        accessibility: []
      },
    }
  },
  created(){
    // Deep copy of the initially blank current filter
    this.blankFilter = JSON.parse(JSON.stringify(this.currentFilter))

    axios.get('/events/filter_options')
      .then(response => {
        this.filterOptions = response.data.filterOptions
        this.filterLoaded = true
      })
  },
  computed: {
    anyFiltersSet(){
      return Object.keys(this.currentFilter).some(type =>
        JSON.stringify(this.blankFilter[type]) !== JSON.stringify(this.currentFilter[type])
      )
    },
    currentFilterDate() {
      const dateString = this.currentFilter.dateString
      if (!dateString) return null
      const [day, month, year] = dateString.split('.')
      return new Date(Date.UTC(parseInt(year), month - 1, parseInt(day)))
    },
    filteredEvents(){
      let filterWords = this.currentFilter.term.toLowerCase().split(/\s+/).filter(Boolean)
      let date = this.currentFilterDate

      return this.events.filter(event => {
        // Governing filtering strategy:
        // If some filter is selected: discard the event if it does not match

        // Text filter
        let eventIncludesFilterWords = filterWords.some(word => event.searchString.includes(word))
        if (filterWords.length && !eventIncludesFilterWords) return false

        // Date filter
        if (date) {
          const isoDate = date.toISOString().split('T')[0]
          if (isoDate < event.startDate) return false
          if (event.endDate < isoDate) return false
          if (!event.weekdays.includes(date.getDay())) return false
        }

        // belongs_to associations
        for (const field of ['category', 'eventType', 'district']) {
          let fieldId = field + 'Id'
          let fieldValues = this.currentFilter[field]
          let eventHasAssociation = fieldValues.some(id => event[fieldId] === id)

          if (fieldValues.length && !eventHasAssociation) return false
        }

        // has_many associations
        for (const field of ['audience', 'accessibility', 'weekday']) {
          let fieldIds = field + 'Ids'
          let fieldValues = this.currentFilter[field]
          let eventHasAssociation = fieldValues.some(id => event[fieldIds].includes(id))

          if (fieldValues.length && !eventHasAssociation) { return false }
        }

        return true
      })
    },
  },
  methods: {
    resetFilter(){
      this.currentFilter = JSON.parse(JSON.stringify(this.blankFilter))
      this.$refs.filterBar.setCurrentFilter(this.currentFilter)
    },
    setFilter(filter){
      this.currentFilter = JSON.parse(JSON.stringify(filter))
      this.filterKey++
      this.$refs.eventsList.setCurrentPage(1)

    },
  }
}
